import React, { Component } from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { goBack, push } from 'react-router-redux'

import { getCreateOrgFailed, getOrgId } from 'modules/org/selectors'
import { createOrg, updateOrgProperties } from 'modules/org/actions'

import { getAccessToken, getEmail, getPassword } from 'modules/user/selectors'
import { activateDeal } from 'modules/billing/actions'
import {
  getDeal,
  getCustomerSegment,
  getActivateDealSucceeded,
  getActivateDealFailed,
  activateDealErrorMessage,
  isInvoicedDeal
} from 'modules/billing/selectors'

import CreateAccountStep from '../CreateAccountStep'
import { makeCelebrateUrl } from 'layouts/Deal/utils'
import { NewOrgAssignedProperties, NewOrgAssignedConfiguration } from 'constants/dealConstants'


class CreateAccountFlowManager extends Component {
  state = {
    isProcessingActivation: false
  }

  componentDidUpdate(prevProps) {
    if((prevProps.orgId !== this.props.orgId) && !!this.props.orgId){
      this.onNewOrgCreated(this.props.orgId)
    }

    if((prevProps.createOrgFailed !== !!this.props.createOrgFailed) && this.props.createOrgFailed){
      this.onCreateOrgFailed()
    }

    if((prevProps.activateDealSucceeded !== !!this.props.activateDealSucceeded) && this.props.activateDealSucceeded){
      this.onActivateDealSuccess()
    }

    if((prevProps.activateDealFailed !== !!this.props.activateDealFailed) && this.props.activateDealFailed){
      this.onActivateDealFailed()
    }
  }

  onCreateOrgFailed = () => {
    this.setState({
      activateAccountFailed: true,
      activateAccountErrorMessage: "We encountered an error trying to create your Drift account - please try again",
      isProcessingActivation: false
    })
  }

  onNewOrgCreated = () => {
    this.props.actions.activateDeal({ dealId: this.props.deal.id, accessToken: this.props.accessToken })
  }

  onActivateDealSuccess = () => {
    this.props.actions.updateOrgProperties({
      properties: NewOrgAssignedProperties,
      redirect: true,
      redirectUrl: makeCelebrateUrl(this.props.customerSegment)
    })
  }

  onActivateDealFailed = () => {
    this.setState({
      activateAccountFailed: true,
      activateAccountErrorMessage: this.props.activateDealFailedErrorMessage,
      isProcessingActivation: false
    })
  }

  onNextClicked = () => {
    this.setState({ isProcessingActivation: true })
    this.props.actions.createOrg({ email: this.props.email, password: this.props.password, configurationOptions: NewOrgAssignedConfiguration })
  }

  moveToNextStep = () => {
    if(!this.props.isInvoiced){
      return this.props.actions.push(`/deal/billing`)
    }
    return this.onNextClicked()
  }

  render() {
    const { isProcessingActivation, activateAccountFailed, activateAccountErrorMessage } = this.state
    return (
      <div>
        <CreateAccountStep onNextClicked={this.moveToNextStep} isProcessing={isProcessingActivation}/>
        {activateAccountFailed &&
        <div className="deal-billing-info-create-failed">
          {activateAccountErrorMessage}
        </div>
        }
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    email: getEmail(state),
    password: getPassword(state),
    orgId: getOrgId(state),
    deal: getDeal(state),
    isInvoiced: isInvoicedDeal(state),
    customerSegment: getCustomerSegment(state),
    accessToken: getAccessToken(state),
    activateDealSucceeded: getActivateDealSucceeded(state),
    activateDealFailed: getActivateDealFailed(state),
    createOrgFailed: getCreateOrgFailed(state),
    activateDealFailedErrorMessage: activateDealErrorMessage(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
    pop: goBack,
    createOrg,
    updateOrgProperties,
    activateDeal
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccountFlowManager)



// WEBPACK FOOTER //
// ./src/layouts/Deal/CreateAccountFlowManager/index.js